import { ThemeColorsKeys } from '@agria/theme/src/styles/tokens/colors';

interface ThemeConfig {
  backgroundColor: ThemeColorsKeys;
  color: ThemeColorsKeys;
  includeInverseFocus: boolean;
  includePhoneNumber: boolean;
}

const themeConfig: ThemeConfig = {
  backgroundColor: 'utilityWhite',
  color: 'brandOne100',
  includeInverseFocus: false,
  includePhoneNumber: true,
};

export default themeConfig;
